import React, { Component } from "react";
import Modal from "../UIComponents/CustomModal/Modal";
import "./SearchTipModal.scss";

class SearchTipModal extends Component {
    render() {
        return (
            <Modal className="search-tip-model" show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>Search Terms Tips</Modal.Header>
                <Modal.Content className="search-tip-model-content">
                    <p>
                        Please note that singular as well as combinations of keywords/hashtags are also accepted. Combinations of keywords need to follow the
                        operator rules. These have been simply summarized below -
                    </p>
                    <ul>
                        <li>
                            &quot;apple juice&quot;
                            <br />
                            Put phrase inside <b>quotes</b> for an exact match
                        </li>
                        <br />
                        <li>
                            &quot;Apple juice&quot; OR &quot;orange juice&quot;
                            <br />
                            Combine searches by putting the <b>OR</b> operator in capital letters between each search term/phrase
                        </li>
                        <br />
                        <li>
                            &quot;Apple&quot; AND &quot;orange&quot;
                            <br />
                            Use the <b>AND</b> operator in capital letters to search for multiple keywords in the same article or post
                        </li>
                        <br />
                        <li>
                            &quot;apple&quot; NOT &quot;orange&quot;
                            <br />
                            Use the <b>NOT</b> operator to exclude results which match specific keywords such as in this case, &quot;orange&quot;
                        </li>
                        <br />
                        <li>
                            You can further combine all of the above to create a more complex and specific search query such as the below -<br />
                            ((apple OR orange OR grape OR &quot;sweet lime&quot;) AND (juice)) NOT fruit
                            <br />
                            As you can see above, you can use brackets to effectively group your search terms and use multiple operators together.
                        </li>
                    </ul>
                </Modal.Content>
            </Modal>
        );
    }
}

export default SearchTipModal;
